/** Dispatched to open Settings collapse before a settings submenu tour. */
export const OPEN_SETTINGS_FOR_TOUR_EVENT = "territory:open-settings-for-tour";

export function dispatchOpenSettingsForTour() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(OPEN_SETTINGS_FOR_TOUR_EVENT));
  }
}
